<template>
    <v-card
        v-if="!isLoading"
        flat
        class="login"
    >
        <v-card-text class="logo">
            <span class="main-title">{{ $t('app.title') }}</span>
            <span class="subtitle">{{ $t('app.subtitle') }}</span>
        </v-card-text>

        <v-card-text v-if="!validAuth">
            <v-alert
                tile
                type="error"
            >
                {{ $t('auth.login.invalid') }}
            </v-alert>
        </v-card-text>

        <v-card-title primary-title>
            <h4>{{ $t(loading ? 'auth.login.successful' : 'auth.login.login') }}</h4>
            <v-spacer></v-spacer>
            <div>
                <v-btn
                    v-for="(locale, i) in altLocals"
                    :key="i"
                    text
                    small
                    @click="$i18n.locale=locale"
                >
                    {{ $t('language.' + locale) }}
                </v-btn>
            </div>
        </v-card-title>

        <v-card-text v-if="loading">
            <v-progress-linear
                color="#00B2D1"
                indeterminate
                rounded
                height="6"
            ></v-progress-linear>
        </v-card-text>

        <v-form
            v-else
            v-on:submit.prevent="login"
        >
            <v-card-text>

                <v-text-field
                    v-model="username"
                    :label="$t('auth.login.username.label')"
                    name="username"
                    prepend-icon="mdi-account"
                    :error-messages="usernameErrors"
                    required
                    @blur="$v.username.$touch()"
                ></v-text-field>
                <v-text-field
                    v-model="password"
                    :label="$t('auth.login.password.label')"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    :error-messages="passwordErrors"
                    required
                    @blur="$v.password.$touch()"
                ></v-text-field>

                <br>
                <v-btn primary large block @click="login" type="submit">
                    {{ $t('auth.login.login') }}
                </v-btn>
                <br>
                <v-btn primary large block @click="linkedinLogin">
                    <v-icon left>mdi-linkedin</v-icon>
                    {{ $t('auth.login.login-linkedin') }}
                </v-btn>
                <br>

                <div class="login__reset">
                    <a :href="routes.root + '/' + $i18n.locale + routes.reset_password">{{
                            $t('auth.login.password.reset')
                        }}</a><br>
                    <a :href="routes.root + '/' + $i18n.locale + routes.register">{{ $t('auth.register.register') }}</a>
                </div>
            </v-card-text>
        </v-form>
    </v-card>
</template>

<script>
// https://materialdesignicons.com/
import {mapGetters} from 'vuex'
import {validationMixin} from 'vuelidate'
import {minLength, email, required} from 'vuelidate/lib/validators'
import {localisation, routing} from '../settings/settings'

export default {
    name: 'Login',
    mixins: [validationMixin],
    validations: {
        username: {
            required,
            email
        },
        password: {
            required,
            minLength: minLength(4)
        }
    },
    data() {
        return {
            ...routing,
            ...localisation,
            username: '',
            password: '',
            validAuth: true,
            loading: false
        }
    },
    computed: {
        ...mapGetters(['isLoading']),
        usernameErrors() {
            const errors = []
            if (!this.$v.username.$dirty) return errors
            !this.$v.username.required && errors.push(this.$t('auth.login.username.required'))
            !this.$v.username.email && errors.push(this.$t('auth.login.username.invalid'))
            return errors
        },
        passwordErrors() {
            const errors = []
            if (!this.$v.password.$dirty) return errors
            !this.$v.password.required && errors.push(this.$t('auth.login.password.required'))
            !this.$v.password.minLength && errors.push(this.$t('auth.login.password.invalid'))
            return errors
        },
        altLocals() {
            return this.validLocals.filter(l => l != this.$i18n.locale)
        }
    },
    methods: {
        login() {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                let me = this
                this.loading = true
                this.validAuth = true

                // try to log in
                this.$store.dispatch('user/login', {
                    username: this.username,
                    password: this.password
                })
                    .then(() => {
                        this.$store.dispatch('initApp')
                        this.$emit('loaded')
                    })
                    .catch(() => {
                        me.loading = false
                        me.validAuth = false
                        me.password = ''
                        this.$v.password.$reset()
                    })
            }
        },

        linkedinLogin() {
            window.location.href = '/login/linkedin'
        }
    }
}
</script>
